// extracted by mini-css-extract-plugin
export default {"page":"styles_page__TRZka","main":"styles_main__i1v1C","mainLogo":"styles_mainLogo__FBmcP"};